import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {Router, RoutesRecognized} from '@angular/router';

@Component({
  selector: 'app-email-change-confirmation',
  templateUrl: './email-change-confirmation.component.html',
  styleUrls: ['./email-change-confirmation.component.scss']
})
export class EmailChangeConfirmationComponent implements OnInit {
  newEmailConfirmed = false;
  notValidConfirmation = false;

  constructor(private authenticationService: AuthenticationService, private router: Router) {
  }

  ngOnInit() {
    this.changeEmailConfirmation();
  }

  private changeEmailConfirmation() {
    if (this.authenticationService.userCurrent) {
      this.authenticationService.logoutUser();
    }
    this.router.events.subscribe(val => {
      if (val instanceof RoutesRecognized) {
        const token = val.state.root.firstChild.params.token;
        this.authenticationService.changeEmailConfirmation(token).subscribe({
            next: () => {
              this.newEmailConfirmed = true;
            },
            error: error => {
              if (error.status === 401 || error.status === 400) {
                this.notValidConfirmation = true;
                return;
              }
            }
          }
        );
      }
    });
  }
}
